module.exports = __webpack_public_path__ + "img/background-notify.226798f3.png";